/** @format */

import axios, { AxiosResponse } from 'axios';
import { sessions } from '../common/localstorage/SessionStorage';

/** Build headers per request so Authorization reflects the latest token. */
export function createRequestHeaders(
  overrides?: Record<string, string>
): Record<string, string> {
  const base: Record<string, string> = {
    'Content-Security-Policy': "default-src 'self'; script-src 'self'; object-src 'none'; style-src 'self'; frame-ancestors 'none';",
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${sessions.getToken() ?? ''}`,
    'X-Frame-Options': 'DENY',
    'X-Content-Type-Options': 'nosniff',
    'X-XSS-Protection': '1; mode=block',
  };
  return overrides ? { ...base, ...overrides } : base;
}
//export const baseURL = process.env.REACT_APP_API_BASEURL;
 //export const baseURL = "https://localhost:44366/api/";
 //export const baseURL = 'https://thuthuka-api.azurewebsites.net/api/';
export const baseURL = 'https://thuthuka-prod-api.azurewebsites.net/api/';
//export const baseURL ='https://thuthuka-preprod-api-cxf2bwbgg4gpadh5.westeurope-01.azurewebsites.net/api/';
//export const baseURL ='https://thuthuka-uat-api-eggeexf9cgdshvgm.westeurope-01.azurewebsites.net/api/';
 //export const baseURL = 'http://localhost/thuthukaApi/api/';

export const axiosCalls = {
  get: async (url: string) => {
    const res = await axios.get(`${baseURL + url}`, {
      headers: createRequestHeaders(),
    });
    return res.data;
  },
  post: async (payload: any, url: string) => {
    const { data } = await axios.post<any, AxiosResponse<any>>(
      `${baseURL + url}`,
      payload,
      { headers: createRequestHeaders() }
    );
    return data;
  },
  put: async (payload: any, url: string) => {
    const { data } = await axios.put<any, AxiosResponse<any>>(
      `${baseURL + url}`,
      payload,
      { headers: createRequestHeaders() }
    );
    return data;
  },
  patch: async (payload: any, url: string) => {
    const { data } = await axios.patch<any, AxiosResponse<any>>(
      `${baseURL + url}`,
      payload,
      { headers: createRequestHeaders() }
    );
    return data;
  },
  delete: async (url: string) => {
    const { data } = await axios.delete(`${baseURL + url}`, {
      headers: createRequestHeaders(),
    });

    return data;
  },
};
